import { CircularProgress } from '@mui/material';

export const CenteredCircularProgress = () => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default CenteredCircularProgress;
